var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.125,
    height: 14.125,
    viewBox: "0 0 14.125 14.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Close",
    d: "M21.647,8.936,20.236,7.523,14.589,13.17,8.942,7.523,7.522,8.936l5.647,5.647L7.522,20.23l1.413,1.419L14.582,16l5.647,5.647,1.412-1.412L15.994,14.59Z",
    transform: "translate(-7.522 -7.523)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/CloseBlack.df7b188a775f1e89b28ce438f161cf26.svg";
export { ForwardRef as ReactComponent };